import seller1 from "../img/seller1.jpg";
import seller2 from "../img/seller2.jpg";
import seller3 from "../img/seller3.jpg";
import seller4 from "../img/seller4.jpg";
import seller5 from "../img/seller5.jpg";

const TopSeller = [
  { id: 4, seller_name: "Ralph Edwards", username: "@ralph", imgSrc: seller4 },

  { id: 1, seller_name: "Jane Cooper", username: "@jane", imgSrc: seller1 },
  { id: 2, seller_name: "Ariene McCoy", username: "@ariene", imgSrc: seller2 },
  { id: 3, seller_name: "Theresa Webb", username: "@theresa", imgSrc: seller3 },
  { id: 4, seller_name: "Ralph Edwards", username: "@ralph", imgSrc: seller4 },
  { id: 2, seller_name: "Ariene McCoy", username: "@ariene", imgSrc: seller2 },
  { id: 2, seller_name: "Ariene McCoy", username: "@ariene", imgSrc: seller2 },
  { id: 4, seller_name: "Ralph Edwards", username: "@ralph", imgSrc: seller4 },
  { id: 2, seller_name: "Ariene McCoy", username: "@ariene", imgSrc: seller2 },
  { id: 2, seller_name: "Ariene McCoy", username: "@ariene", imgSrc: seller2 },
  { id: 5, seller_name: "Raplhie", username: "@raplhie", imgSrc: seller5 },
  { id: 4, seller_name: "Ralph Edwards", username: "@ralph", imgSrc: seller4 },

];

export default TopSeller;
